// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1wMRF","item":"PaymentsMobile_item__H5w3N","label":"PaymentsMobile_label__v_aYU","amount":"PaymentsMobile_amount__24K_z"};